module.exports = __webpack_public_path__ + "img/resend-1.2bf1c025.png";